import React from "react";

const ImageArrow = () => {
	return (
		<svg
			className="image-arrow"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<polygon
				className="image-fill-color"
				points="5.074013 7.98131329 11.5463467 14.452899 18.074013 7.925987 18.074013 10.547101 11.5463467 17.074013 5.074013 10.6024273"
			></polygon>
		</svg>
	);
};

export default ImageArrow;
